export default function ({
  _uid,
  _editable,
  sections,
  social_links,
  logo,
  bg_image,
  text_color,
  newsletter_title,
  newsletter_subtitle,
  newsletter_city_placeholder,
  newsletter_cta,
  newsletter_success_text,
  newsletter_success_color,
  newsletter_success_bg_color,
  newsletter_klaviyo_source,
  newsletter_klaviyo_list_id
}) {
  const parseChildren = (children) => {
    const parsedChildren = children.map((item) => {
      const linkData = {
        name: item.label,
        type: 'link',
        highlighted: item.highlight,
        id: item.id
      };
      const isExternalLink = item.link?.startsWith('http');
      if (isExternalLink) linkData.href = item.link;
      else {
        linkData.to = {
          path: item.link
        };
        linkData.id = item.id;
      }

      return linkData;
    });

    return parsedChildren;
  };
  return {
    _uid,
    _editable,
    socialLinks: social_links.map(({ name, icon, url }: { name: string; icon: string; url: string }) => ({
      name,
      icon,
      url
    })),
    sections: sections.map(({ title, children, key }: { title: string; children: any; key: string }) => ({
      title,
      key,
      children: parseChildren(children)
    })),
    logo: logo?.filename,
    bg_image,
    newsletter_title,
    newsletter_subtitle,
    newsletter_city_placeholder,
    newsletter_cta,
    newsletter_success_text,
    newsletter_success_color,
    newsletter_success_bg_color,
    newsletter_klaviyo_source,
    newsletter_klaviyo_list_id,
    text_color: text_color?.color || '#FFFFFF'
  };
}
